import {
  FileArchive,
  FileCode,
  FileImage,
  FileText,
  Folder,
} from 'lucide-react';

export const AnatomyTree = () => {
  return (
    <div
      className='w-full max-w-[380px] rounded-lg border border-border bg-muted p-3 font-mono text-xs leading-[1.85]'
      role='img'
      aria-label='Example skill bundle structure'
    >
      <div className='mb-1.5 flex items-center gap-2 border-b border-border pb-2.5 pt-1 font-sans text-xs font-medium text-muted-foreground'>
        <FileArchive className='size-3.5' />
        pdf-extractor.zip
        <span className='ml-auto font-mono text-[10.5px]'>4.2 KB</span>
      </div>

      <div className='-mx-1 flex items-center gap-1.5 rounded-sm bg-primary/[0.08] px-1 pr-1'>
        <FileText className='size-[13px] shrink-0 text-primary' />
        <span className='font-medium text-primary'>SKILL.md</span>
        <span className='ml-auto text-[10.5px] text-muted-foreground'>
          required
        </span>
      </div>

      <div className='flex items-center gap-1.5'>
        <Folder className='size-[13px] shrink-0 text-muted-foreground' />
        <span className='font-medium'>scripts/</span>
      </div>
      <div className='flex items-center gap-1.5 pl-4'>
        <FileCode className='size-[13px] shrink-0 text-muted-foreground' />
        <span>extract.py</span>
      </div>
      <div className='flex items-center gap-1.5 pl-4'>
        <FileCode className='size-[13px] shrink-0 text-muted-foreground' />
        <span>normalize.py</span>
      </div>

      <div className='flex items-center gap-1.5'>
        <Folder className='size-[13px] shrink-0 text-muted-foreground' />
        <span className='font-medium'>examples/</span>
      </div>
      <div className='flex items-center gap-1.5 pl-4'>
        <FileImage className='size-[13px] shrink-0 text-muted-foreground' />
        <span>invoice-sample.pdf</span>
      </div>
      <div className='flex items-center gap-1.5 pl-4'>
        <FileText className='size-[13px] shrink-0 text-muted-foreground' />
        <span>expected-output.json</span>
      </div>
    </div>
  );
};
